export var AnalyticsResponseCode;
(function (AnalyticsResponseCode) {
    AnalyticsResponseCode[AnalyticsResponseCode["InvalidResponse"] = 1] = "InvalidResponse";
})(AnalyticsResponseCode || (AnalyticsResponseCode = {}));
//# sourceMappingURL=analytics-response-code.js.map